export const OBJECT_CONFIG_SEARCH_FILTER_KEY = 'search_key';
